"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Typography_1 = tslib_1.__importDefault(require("@material-ui/core/Typography"));
var ArrowDropUp_1 = tslib_1.__importDefault(require("@material-ui/icons/ArrowDropUp"));
var ArrowDropDown_1 = tslib_1.__importDefault(require("@material-ui/icons/ArrowDropDown"));
var Accordion_styles_1 = require("./Accordion.styles");
var enums_1 = require("../../enums");
var Tooltip_1 = require("../Tooltip");
var Accordion = function (_a) {
    var title = _a.title, name = _a.name, children = _a.children, expanded = _a.expanded, shadow = _a.shadow, startIcon = _a.startIcon, onExpandHandler = _a.onExpandHandler, tag = _a.tag;
    var classes = (0, Accordion_styles_1.useAccordionStyles)();
    var hasShadow = shadow && expanded;
    var iconButtonProps = {
        disableFocusRipple: true,
        disableRipple: true,
    };
    var expandIcon = expanded ? (react_1.default.createElement(ArrowDropUp_1.default, { className: classes.expandIcon })) : (react_1.default.createElement(ArrowDropDown_1.default, { className: classes.expandIcon }));
    return (react_1.default.createElement(core_1.Accordion, { expanded: expanded, classes: {
            root: classes.accordion,
            rounded: "".concat(classes.rounded, " ").concat(hasShadow ? classes.shadow : ''),
        }, onChange: function (event, expandedChange) { return onExpandHandler(expandedChange); } },
        react_1.default.createElement(core_1.AccordionSummary, { "data-signa": "accordion-".concat(name, "-root"), classes: {
                root: classes.summary,
                expanded: classes.expanded,
                content: classes.content,
                expandIcon: classes.hiddenExpandIcon,
            }, "aria-controls": name, IconButtonProps: iconButtonProps, id: name },
            startIcon && (react_1.default.createElement("div", { "data-signa": "accordion-".concat(name, "-expanded-icon"), className: classes.startIcon }, startIcon)),
            react_1.default.createElement(Tooltip_1.Tooltip, { title: title, placement: Tooltip_1.TooltipPlacement.TOP_START },
                react_1.default.createElement(Typography_1.default, { "data-signa": "accordion-".concat(name, "-title"), className: classes.title, color: enums_1.TypographyColor.primary, variant: "body1" }, title)),
            tag && (react_1.default.createElement("div", { "data-signa": "accordion-".concat(name, "-tag"), className: classes.tag }, tag)),
            expandIcon),
        react_1.default.createElement(core_1.AccordionDetails, { "data-signa": "accordion-".concat(name, "-details"), className: classes.details }, children)));
};
exports.Accordion = Accordion;
